import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AnaSayfa from "../Pages/AnaSayfa";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import HesapSilme from "../Pages/HesapSilme";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<UnderConstruction></UnderConstruction>} exact="true"></Route>
                <Route path="*" element={<UnderConstruction></UnderConstruction>} exact="true" ></Route> */}
        <Route path="*" element={<AnaSayfa></AnaSayfa>} exact="true"></Route>

        <Route path="/" element={<AnaSayfa></AnaSayfa>} exact="true"></Route>
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
          exact="true"
        ></Route>
        <Route
          path="/hesap-silme"
          element={<HesapSilme />}
          exact="true"
        ></Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
